/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {SystemOfUnitsMap} from '@ion/core/src/types/general';
import {createDeepEqualSelector} from '../../store/selectors/SelectorUtils';

// input selectors ...
const selectSystemOfUnits        = ({login: {user}}) => user.systemOfUnits;

// output selectors ...
export const systemOfUnitsSelector = createDeepEqualSelector(selectSystemOfUnits,
  (systemOfUnits: SystemOfUnitsMap): SystemOfUnitsMap => systemOfUnits
);
